import stopRepository from '@/repositories/bookings/stopRepository'
import apiState from '@/core/enums/apiStates'
import { Commit } from 'vuex'

const stopStore = {
  namespaced: true,
  state: {
    stopRoute: {},
    stopRouteState: apiState.INIT,
    // #1260 - Which stop the temperature status in stopRoute belongs to. Null means nothing has
    // been loaded for the stop on screen yet.
    stopRouteStopId: null,
    // #1260 - Three things fetch this status (mount, the currentStop watch, the 30 second timer),
    // so a slow older response could land after a newer one and leave the store pointing at the
    // wrong stop. Only the newest request is allowed to write.
    stopRouteRequestSeq: 0,
    detailsOpen: false,
    details: {},
    serviceFunctionsOpen: false,
    serviceFunctionType: null,
    pendingStop: null,
  },
  getters: {
    stopRouteState (state: any) {
      return state.stopRouteState
    },
    stopRoute (state: any) {
      return state.stopRoute
    },
    stopRouteStopId (state: any) {
      return state.stopRouteStopId
    },
    detailsOpen (state: any) {
      return state.detailsOpen
    },
    getDetails (state: any) {
      return state.details
    },
    serviceFunctionsOpen (state: any) {
      return state.serviceFunctionsOpen
    },
    serviceFunctionType (state: any) {
      return state.serviceFunctionType
    },
    pendingStop(state: any) { return state.pendingStop }
  },
  mutations: {
    setStopRouteRequestSeq: (state: any, seq: number) => {
      state.stopRouteRequestSeq = seq
    },
    setStopRouteState: (state: any, apiState: any) => {
      state.stopRouteState = apiState
    },
    setStopRoute: (state: any, payload: any) => {
      const { data } = payload.response
      state.stopRoute = data
      state.stopRouteStopId = payload.stopId
      state.stopRouteState = apiState.LOADED
    },
    // #1260 - Without this, the previous booking's temperature status stays in the store while the
    // next one loads, and the start button gets evaluated against another trailer's readings.
    clearStopRoute: (state: any) => {
      state.stopRoute = {}
      state.stopRouteStopId = null
      state.stopRouteState = apiState.INIT
    },
    setDetails (state: any, details: any) {
      console.log('setting details to: ', details)
      state.details = details
      console.log('details state is: ', state.details)
    },
    toggleDetailsOpen (state: any) {
      state.detailsOpen = !state.detailsOpen
    },
    toggleServiceFunctions (state: any) {
      state.serviceFunctionsOpen = !state.serviceFunctionsOpen
    },
    setServiceFunctionType (state: any, type: string) {
      state.serviceFunctionType = type
    },
    clearStopDetails: (state: any) => {
      state.details = {}
      state.detailsOpen = false
    },
    setPendingStop(state: any, stop: any) { state.pendingStop = stop },
    clearPendingStop(state: any) { state.pendingStop = null },
  },
  actions: {
    async getStopRouteStatus ({ commit, state }: { commit: Commit, state: any }, dto: any) {
      const seq = state.stopRouteRequestSeq + 1
      commit('setStopRouteRequestSeq', seq)
      commit('setStopRouteState', apiState.LOADING)
      try {
        const response = await stopRepository.getStopRouteStatus(dto.id, dto.toAddress)
        if (state.stopRouteRequestSeq !== seq) {
          return
        }
        commit('setStopRoute', { response, stopId: dto.id })
      } catch (error) {
        if (state.stopRouteRequestSeq !== seq) {
          return
        }
        commit('setStopRouteState', apiState.ERROR)
      }
    },
    async showStopDetails ({ commit }: { commit: Commit}, stopDetails: any) {
      console.log('setting stop to: ', stopDetails)
      commit('setDetails', stopDetails)
      commit('toggleDetailsOpen')
    },
    async toggleDetails ({ commit }: { commit: Commit}) {
      commit('toggleDetailsOpen')
    },
    async clearStopRoute ({ commit }: { commit: Commit }) {
      commit('clearStopRoute')
    },
    async clearStopDetails ({ commit }: { commit: Commit }) {
      commit('clearStopDetails')
    },
    async setPendingStop({ commit }: { commit: Commit }, stop: any) {
      commit('setPendingStop', stop)
    },
    async clearPendingStop({ commit }: { commit: Commit }) {
      commit('clearPendingStop')
    },
  },
  modules: {
  }
}

export default stopStore
